import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import type { RecipientDetailsMasked } from '@/types/payout';
import { parseRecipientDetailsMasked } from '@/utils/payout';

function RecipientStructured({ data }: { data: RecipientDetailsMasked }) {
  if (data.type === 'card') {
    return (
      <Stack spacing={0.25}>
        <Typography variant="caption" color="text.secondary">
          Карта
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
          {data.number}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {data.initials}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={0.25}>
      <Typography variant="caption" color="text.secondary">
        СБП
      </Typography>
      <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
        {data.phone}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {data.initials}
      </Typography>
    </Stack>
  );
}

const RecipientMaskedCell: React.FC<{ value: unknown }> = ({ value }) => {
  const parsed = parseRecipientDetailsMasked(value);

  if (parsed === null) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  if (typeof parsed === 'string') {
    return (
      <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
        {parsed}
      </Typography>
    );
  }

  return (
    <Box sx={{ maxWidth: 280 }}>
      <RecipientStructured data={parsed} />
    </Box>
  );
};

export default RecipientMaskedCell;
